
import { LoginResponse } from '../../src/features/auth/types/Login/auth.types';

const TOKEN_KEY = 'token';
const EMPLOYEE_ID_KEY = 'employeeId';
const EMPLOYEE_CODE_KEY = 'employeeCode';
const EMPLOYEE_NAME_KEY = 'employeeName';
const ROLES_KEY = 'roles';
const ROLE_KEY = 'role';

export const saveLogin = (data: LoginResponse): void => {
  localStorage.setItem(TOKEN_KEY, data.token);
  localStorage.setItem(EMPLOYEE_ID_KEY, String(data.employeeId));
  localStorage.setItem(EMPLOYEE_CODE_KEY, data.employeeCode);
  localStorage.setItem(EMPLOYEE_NAME_KEY, data.employeeName);
  localStorage.setItem(ROLES_KEY, JSON.stringify(data.roles ?? []));
  localStorage.setItem(
    ROLE_KEY,
    data.roles?.[0]?.roleName ?? 'Employee',
  );
};

export const clearAuthStorage = (): void => {
  const keys = [
    TOKEN_KEY,
    EMPLOYEE_ID_KEY,
    EMPLOYEE_CODE_KEY,
    EMPLOYEE_NAME_KEY,
    ROLES_KEY,
    ROLE_KEY,
    'roleId',
    'rolePermissions',
  ];

  keys.forEach((key) => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  });
};

export const getToken = (): string =>
  localStorage.getItem(TOKEN_KEY) ??
  sessionStorage.getItem(TOKEN_KEY) ??
  '';

export const getEmployeeId = (): string =>
  localStorage.getItem(EMPLOYEE_ID_KEY) ?? '';

export const getEmployeeCode = (): string =>
  localStorage.getItem(EMPLOYEE_CODE_KEY) ??
  sessionStorage.getItem(EMPLOYEE_CODE_KEY) ??
  '';

export const getEmployeeName = (): string =>
  localStorage.getItem(EMPLOYEE_NAME_KEY) ?? '';

export const getRole = (): string =>
  localStorage.getItem(ROLE_KEY) ?? 'Employee';

export const getRoles = <T = unknown>(): T[] => {
  try {
    const value = localStorage.getItem(ROLES_KEY);
    if (!value) return [];

    const parsed: unknown = JSON.parse(value);
    return Array.isArray(parsed) ? (parsed as T[]) : [];
  } catch {
    return [];
  }
};

export const saveEmployeeRoles = <T>(roles: T[]): void => {
  localStorage.setItem(ROLES_KEY, JSON.stringify(roles));
  window.dispatchEvent(new Event('workvista-auth-updated'));
};
